import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'jsonDiff',
})
export class jsonDiffPipe implements PipeTransform {
  transform(a: any, b: any, excludeProperty: any = null): boolean {
    let cloneA = JSON.parse(JSON.stringify(a));
    let cloneB = JSON.parse(JSON.stringify(b));
    if (excludeProperty?.formControlName) {
      try {
        cloneA[0][excludeProperty.formControlName] = '';
        cloneB[0][excludeProperty.formControlName] = '';
      } catch (error) {}
    }
    return JSON.stringify(cloneA) != JSON.stringify(cloneB);
  }
}
